import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.25 8.414h7.5m-7.5 2.5h7.5M2.5 16.54V4.663a.625.625 0 0 1 .625-.625h13.75a.625.625 0 0 1 .625.625V16.54L15 15.29l-2.5 1.25-2.5-1.25-2.5 1.25L5 15.29z"
    }, null, -1)
  ]))]))
}
export default { render: render }